export type CommentRowFrameVariant = {
  hasFooter: boolean;
  hasHeaderActions: boolean;
  replyRail: boolean;
  surfaceTone: 'parent' | 'reply';
};

export function commentRowFrameVariant({
  hasFooter = false,
  hasHeaderActions = false,
  isReply = false,
}: {
  hasFooter?: boolean;
  hasHeaderActions?: boolean;
  isReply?: boolean;
}): CommentRowFrameVariant {
  return {
    hasFooter,
    hasHeaderActions,
    replyRail: isReply,
    surfaceTone: isReply ? 'reply' : 'parent',
  };
}
